import { ThunkAction } from 'redux-thunk';
import { Action, Dispatch, ActionCreator } from 'redux';

import { AppState } from '../index';
import { Action as FetchAction, ActionTypes } from './types';

import { getPermissions } from '../../services/permissions';
import { getUserData } from '../../services/localSorage';
import { getUnleash } from '../../services/unleash/unleash';

export const fetchPermissions: ActionCreator<ThunkAction<void, AppState, null, Action<FetchAction>>> =
  () =>
    async (dispatch: Dispatch<FetchAction>): Promise<void> => {
      try {
        const { user, token } = getUserData();

        if (!user && !token) return;

        dispatch({
          type: ActionTypes.FETCH,
        });

        const permissions = await getPermissions(Number(user?.id), String(token));

        dispatch({
          type: ActionTypes.FETCH_SUCCESS,
          permissions,
        });

        const userId = user?.id;
        const chainId = permissions?.current_drugstore?.chain?.id;
        const drugstoreId = permissions?.current_drugstore?.id;
        const drugstoreUF = permissions?.current_drugstore?.uf;
        if (userId) {
          await getUnleash({
            userId,
            drugstoreChainId: chainId ?? '',
            drugstoreId: drugstoreId ?? '',
            drugstoreUF: drugstoreUF ?? ''
          });
        }
      } catch (catchError) {
        dispatch({
          type: ActionTypes.FETCH_ERROR,
        });
      }
    };
